import { WidgetType } from '../content/contentBuilder/widgets/widgetType';
import { ContentFragmentType } from '../content/contentBuilder/Content';
export const convertListWidgetToServerModel = (widget) => {
    return {
        id: widget._id,
        trackingIdentifier: widget.trackingIdentifier,
        type: WidgetType.list,
        data: { ...widget.value.data },
        properties: {
            ...widget.value.properties,
        },
    };
};
export const convertListFromServerModel = (serverModel) => {
    return {
        _id: serverModel.id,
        type: ContentFragmentType.Widget,
        initialized: true,
        trackingIdentifier: serverModel.trackingIdentifier,
        value: {
            type: WidgetType.list,
            data: {
                ...serverModel.data,
            },
            properties: {
                ...serverModel.properties,
            },
        },
    };
};
